module.exports = __webpack_public_path__ + "static/media/-_Employee Core Data.931064a8.png";